<div class="table-container">
  <!-- Table Header -->
  @if (showHeader) {
    <div class="table-header">
      <div class="table-title">
        <h2>{{title}}</h2>
        <span class="record-count">{{dataSource.filteredData.length}} / {{dataSource.data.length}} rekord</span>
      </div>
    </div>
  }

  <!-- Data Table Desktop View -->
  <div class="table-wrapper desktop-view">
    <table mat-table [dataSource]="dataSource" matSort class="data-table">

      <!-- Biztosító / Kötvényszám Column -->
      <ng-container matColumnDef="insurer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="insurer" style="text-align: center;">Biztosító / Kötvényszám</th>
        <td mat-cell *matCellDef="let element">
          <div class="insurer-cell">
            <div class="insurer-name"><strong>{{element.insurancecompanyname || 'Nincs biztosító'}}</strong></div>
            <div class="policy-number">{{element.policynumber || 'Nincs kötvényszám'}}</div>
          </div>
        </td>
      </ng-container>

      <!-- Módozat / Termék Column -->
      <ng-container matColumnDef="product">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="product" style="text-align: center;">Módozat / Termék</th>
        <td mat-cell *matCellDef="let element">
          <div class="product-cell">

            <div class="product">
              <div class="product-code">{{element.productcode || 'Nincs kód'}}</div>
              <div class="product-name">{{element.productname || 'Nincs termék'}}</div>

            </div>
          </div>
        </td>
      </ng-container>

      <!-- Személyek Column -->
      <ng-container matColumnDef="person">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;">
          <mat-icon class="person-icon">person</mat-icon>
          Szerződő /
          <mat-icon class="person-icon">person_outline</mat-icon>
          Biztosított
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="person-cell">
            <div class="policyholder">
              <mat-icon class="person-icon">person</mat-icon>
              <span>{{element.policyholdercustomername || element.policyholdercompanyname || 'Nincs szerződő'}}</span>
            </div>
            <div class="insured">
              <mat-icon class="person-icon">person_outline</mat-icon>
              <span>{{element.insuredcustomername || element.insuredcompanyname || element.policyholdercustomername || element.policyholdercompanyname || 'Nincs biztosított'}}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Indulás Column -->
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="startdate" style="text-align: center;">Indulás</th>
        <td mat-cell *matCellDef="let element">
          {{formatDate(element.startdate)}}
        </td>
      </ng-container>

      <!-- Rendezve & Hátralékos napok Combined Column -->
      <ng-container matColumnDef="settlement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="settlementdate" style="text-align: center;">Rendezve / Hátralékos napok</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <div class="settlement-debt-cell">
            <div class="settlement-date">
              {{element.settlementdate ? formatDate(element.settlementdate) : '-'}}
            </div>
            @if (element.settlementdate && element.status !== 'törölt' && element.status !== 'visszavásárolt') {
              @if (getOverdueSettlementDays(element.settlementdate)) {
                <div class="debt-info overdue-settlement">
                  <span class="overdue-days">{{getOverdueSettlementDays(element.settlementdate)}} nap</span>
                </div>
              } @else if ((element.dayofarrears || 0) > 0) {
                <div class="debt-info overdue-settlement">
                  <span class="arrears-days">{{element.dayofarrears}} nap hátralék</span>
                </div>
              } @else {
                <div class="debt-info no-arrears">
                  Nincs hátralék
                </div>
              }
            }
          </div>
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="status" style="text-align: center;">Státusz</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <app-call-center-chip [config]="getContractStatusChip(element.status)"></app-call-center-chip>
        </td>
      </ng-container>

      <!-- Díj Column -->
      <ng-container matColumnDef="premium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="insurancepremium" style="text-align: center;">Díj / GYAK</th>
        <td mat-cell *matCellDef="let element">
          <div class="currency-cell">
            <div>{{formatPremium(element.insurancepremium || 0, element.currency || 'HUF')}}</div>
            <div class="frequency-info">{{element.paymentfrequency || 'N/A'}}</div>
          </div>
        </td>
      </ng-container>

      <!-- Állomány Column -->
      <ng-container matColumnDef="portfolio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="portfolio" style="text-align: center;">Állomány</th>
        <td mat-cell *matCellDef="let element">
          <div class="portfolio-cell">
            <div>{{formatPortfolio(element.annualpremium || 0, element.currency || 'HUF')}}</div>
          </div>
        </td>
      </ng-container>

      <!-- Pénznem Column -->
      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="currency" style="text-align: center;">Pénznem</th>
        <td mat-cell *matCellDef="let element">
          <mat-chip class="currency-chip">{{element.currency || 'HUF'}}</mat-chip>
        </td>
      </ng-container>

      <!-- Lejárat Column -->
      <ng-container matColumnDef="expiry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="enddate" style="text-align: center;">Lejárat</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          {{element.enddate ? formatDate(element.enddate) : '-'}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        (click)="navigateToCustomerDetails(row)"
        class="clickable-row"
      [title]="getRowTooltip(row)"></tr>
    </table>
  </div>

  <!-- Mobile Card View -->
  <div class="mobile-view contracts-mobile-view">
    @for (element of paginatedData; track trackById($index, element)) {
      <div class="mobile-card contracts-mobile-card"
        (click)="navigateToCustomerDetails(element)"
        [title]="getRowTooltip(element)">
        <!-- Card Header - Kötvényszám, Debt Info és Státusz -->
        <div class="card-header">
          <div class="policy-info">
            <div class="policy-number">
              <mat-icon class="contract-icon">description</mat-icon>
              <strong>{{element.policynumber || 'Nincs kötvényszám'}}</strong>
            </div>
            <div class="insurer-name">{{element.insurancecompanyname || 'Nincs biztosító'}}</div>
          </div>
          <!-- Debt Info középen -->
          <div class="debt-info-center">
            @if (element.settlementdate && element.status !== 'törölt' && element.status !== 'visszavásárolt') {
              @if (getOverdueSettlementDays(element.settlementdate)) {
                <div class="debt-info overdue-settlement">
                  <span class="overdue-days">{{getOverdueSettlementDays(element.settlementdate)}} nap</span>
                </div>
              } @else if ((element.dayofarrears || 0) > 0) {
                <div class="debt-info overdue-settlement">
                  <span class="arrears-days">{{element.dayofarrears}} nap hátralék</span>
                </div>
              } @else {
                <div class="debt-info no-arrears">
                  Nincs hátralék
                </div>
              }
            }
          </div>
          <app-call-center-chip [config]="getContractStatusChip(element.status)"></app-call-center-chip>
        </div>
        <!-- Card Content - Kompakt elrendezés -->
        <div class="card-content">
          <!-- Termék és Személyek egy sorban -->
          <div class="card-row" style="display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 12px;">
            <div class="card-section half-width" style="flex: 1; min-width: 0; max-width: 50%;">
              <div class="section-label">Termék</div>
              <div class="product-compact">
                <div class="product-name">{{element.productname || 'Nincs termék'}}</div>
                @if (element.productcode) {
                  <div class="product-code">{{element.productcode}}</div>
                }
              </div>
            </div>
            <div class="card-section half-width" style="flex: 1; min-width: 0; max-width: 50%;">
              <div class="section-label">Szerződő</div>
              <div class="person-compact">
                <mat-icon class="person-icon">person</mat-icon>
                <span class="person-name">{{element.policyholdercustomername || element.policyholdercompanyname || 'Nincs'}}</span>
              </div>
              <!-- Biztosított neve, ha különbözik a szerződőtől -->
              @if ((element.insuredcustomername && element.insuredcustomername !== element.policyholdercustomername) || (element.insuredcompanyname && element.insuredcompanyname !== element.policyholdercompanyname)) {
                <div class="person-compact">
                  <mat-icon class="person-icon">person_outline</mat-icon>
                  <span class="person-name insured-name">{{element.insuredcustomername || element.insuredcompanyname}}</span>
                </div>
              }
            </div>
          </div>
          <!-- Díj és Dátumok egy sorban -->
          <div class="card-row" style="display: flex; flex-wrap: nowrap; align-items: flex-start; gap: 12px;">
            <div class="card-section half-width" style="flex: 1; min-width: 0; max-width: 50%;">
              <div class="section-label">Díj / Gyakoriság</div>
              <div class="premium-compact">
                <div class="premium-amount">{{formatPremium(element.insurancepremium || 0, element.currency || 'HUF')}}</div>
                <div class="frequency">{{element.paymentfrequency || 'N/A'}}</div>
              </div>
            </div>
            <div class="card-section half-width" style="flex: 1; min-width: 0; max-width: 50%;">
              <div class="section-label">Dátumok</div>
              <div class="dates-compact">
                <div class="start-date">
                  <strong>Indulás:</strong> {{formatDate(element.startdate)}}
                </div>
                @if (element.settlementdate) {
                  <div class="settlement-date">
                    <strong>Rendezve:</strong> {{formatDate(element.settlementdate)}}
                  </div>
                }
                @if (element.enddate) {
                  <div class="end-date">
                    <strong>Lejárat:</strong> {{formatDate(element.enddate)}}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Paginator -->
  <mat-paginator
    [length]="dataSource.filteredData.length"
    [pageSizeOptions]="[10, 25, 50, 100]"
    [pageSize]="25"
    showFirstLastButtons>
  </mat-paginator>
</div>